export default __webpack_public_path__ + "static/media/Logo.647cfa20.jpg";